import React from 'react';
import {useSearchParams} from 'react-router-dom';
import _ from 'lodash';
import {useCustomTheme} from './hooks/use-custom-theme';
import Layout from './components/Layout';
import {NEW_UI_COUNTRIES} from './constants';
import { Variant } from './constants/variants';
import WhereToBuy from './components/WhereToBuy';
import Product from './components/Product';
import ProductInformation from './components/ProductInformation';
import Landing from './components/Landing';

function App() {
  const [params] = useSearchParams();
  const page = params.get('page');
  const variant = params.get('variant');
  const isFord = variant === Variant.FORD;
  useCustomTheme();
  const country = (localStorage.getItem('countryCode') ||
    process.env.REACT_APP_COUNTRYCODE) as string;
  if (_.includes(NEW_UI_COUNTRIES, country) || isFord) {
    return <Layout />;
  } else {
    switch (page) {
      case '':
      case 'wheretobuy':
        return <WhereToBuy />;
      case 'recommendedProducts':
        return <Product />;
      case 'product':
        return <ProductInformation />;
      default:
        return <Landing />;
    }
  }
}

export default App;
